import React from "react";
import { Link, useParams } from "react-router-dom";
import ConsultancyNavbar from "../ConsultancyNavbar";
import ConsultancyFooter from "../ConsultancyFooter";

const DestinationDetailPage = () => {
  const { countryId } = useParams();

  const dataMap = {
    uk: { flag: "🇬🇧", name: "United Kingdom", banner: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=1200&q=80", fee: "£14,000 - £35,000 / yr", living: "£9,000 - £12,000 / yr", psw: "2 Years Graduate Route Visa", intakes: "September (Primary) & January" },
    usa: { flag: "🇺🇸", name: "United States", banner: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?auto=format&fit=crop&w=1200&q=80", fee: "$20,000 - $55,000 / yr", living: "$10,000 - $15,000 / yr", psw: "up to 36 Months OPT (STEM)", intakes: "Fall (August) & Spring (January)" },
    canada: { flag: "🇨🇦", name: "Canada", banner: "https://images.unsplash.com/photo-1503614472-8c93d56e92ce?auto=format&fit=crop&w=1200&q=80", fee: "CAD 18,000 - 45,000 / yr", living: "CAD 12,000 - 15,000 / yr", psw: "3 Years Post-Graduation Work Permit", intakes: "September, January & May" },
    germany: { flag: "🇩🇪", name: "Germany", banner: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?auto=format&fit=crop&w=1200&q=80", fee: "€0 Tuition (Public Universities)", living: "€11,208 / yr (Blocked Account)", psw: "18 Months Job Seeking Visa", intakes: "Winter (October) & Summer (April)" },
  };

  const current = dataMap[countryId] || dataMap["uk"];

  return (
    <div className="consultancy-wrapper">
      <ConsultancyNavbar />

      {/* Banner */}
      <section className="position-relative py-5" style={{ background: `linear-gradient(180deg, rgba(10,10,10,0.7) 0%, rgba(10,10,10,0.95) 100%), url(${current.banner}) center/cover no-repeat`, minHeight: "50vh", borderBottom: "1px solid rgba(212, 175, 55, 0.12)" }}>
        <div className="container py-5 text-center position-relative z-2">
          <span className="fs-1 d-block mb-2">{current.flag}</span>
          <span className="consultancy-badge-gold mb-2">Study Destination Guide</span>
          <h1 className="display-4 font-weight-bold consultancy-gold-title mb-3">Study in {current.name}</h1>
          <p className="consultancy-lead-text mx-auto mb-4" style={{ maxWidth: "680px" }}>
            Explore world-renowned academic excellence, vibrant multicultural student cities, and post-study career opportunities in {current.name}.
          </p>
          <Link to="/consultancy/book-consultation" className="consultancy-btn-gold px-5 py-3">
            Apply to Study in {current.name} <i className="fas fa-paper-plane ml-1"></i>
          </Link>
        </div>
      </section>

      {/* Details Breakdown Grid */}
      <section className="py-5 container">
        <div className="row g-4">
          <div className="col-lg-8">
            <div className="consultancy-glass-card p-4 p-md-5 mb-4">
              <h3 className="consultancy-gold-title font-weight-bold mb-3">Why Study in {current.name}?</h3>
              <p className="text-muted" style={{ lineHeight: "1.8" }}>
                {current.name} is home to some of the world's most prestigious universities and research institutes. International students gain access to world-class faculty, industry-integrated internships, and generous post-study work visa rights that launch global careers.
              </p>

              <h4 className="consultancy-gold-title font-weight-bold mt-4 mb-3">Key Highlights & Statistics</h4>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="consultancy-pill-card">
                    <small className="text-muted font-weight-bold d-block">AVERAGE TUITION</small>
                    <span className="text-warning font-weight-bold fs-5">{current.fee}</span>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="consultancy-pill-card">
                    <small className="text-muted font-weight-bold d-block">ESTIMATED LIVING COST</small>
                    <span className="text-white font-weight-bold fs-5">{current.living}</span>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="consultancy-pill-card">
                    <small className="text-muted font-weight-bold d-block">POST-STUDY WORK VISA</small>
                    <span className="text-warning font-weight-bold fs-5">{current.psw}</span>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="consultancy-pill-card">
                    <small className="text-muted font-weight-bold d-block">PRIMARY INTAKES</small>
                    <span className="text-white font-weight-bold fs-5">{current.intakes}</span>
                  </div>
                </div>
              </div>

              <h4 className="consultancy-gold-title font-weight-bold mt-5 mb-3">Admission & Student Visa Requirements</h4>
              <ul className="text-muted list-unstyled d-flex flex-column gap-2">
                <li><i className="fas fa-check-circle text-warning mr-2"></i> Academic transcripts & provisional degree certificates (minimum 60%+ required).</li>
                <li><i className="fas fa-check-circle text-warning mr-2"></i> Proof of English Proficiency (IELTS Academic 6.5+ / TOEFL 85+ / Duolingo 115+).</li>
                <li><i className="fas fa-check-circle text-warning mr-2"></i> Statement of Purpose (SOP) detailing your academic & career aspirations.</li>
                <li><i className="fas fa-check-circle text-warning mr-2"></i> 2-3 Letters of Recommendation (LORs) from professors or employers.</li>
                <li><i className="fas fa-check-circle text-warning mr-2"></i> Financial proof covering 1 year of tuition and living expenses.</li>
              </ul>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="consultancy-glass-card p-4 border-warning sticky-top" style={{ top: "100px" }}>
              <h5 className="consultancy-gold-title font-weight-bold mb-3">Interested in {current.name}?</h5>
              <p className="text-muted small mb-4">
                Get personalized guidance from our senior counselors for admission shortlisting, SOP editing, and 100% visa filing.
              </p>
              <Link to="/consultancy/book-consultation" className="consultancy-btn-gold w-100 text-center mb-3">
                Book Free Counselling <i className="fas fa-calendar-alt ml-1"></i>
              </Link>
              <Link to="/consultancy/universities" className="consultancy-btn-outline-gold w-100 text-center">
                Explore {current.name} Unis <i className="fas fa-university ml-1"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <ConsultancyFooter />
    </div>
  );
};

export default DestinationDetailPage;
